import styled from '../../../../../../../styles/styledComponents/themeComponents';

export const EventWidgetPreviewModalStyle = styled.div`
  .preview-area {
    margin-top: 20px;
    display: flex;

    & > div {
      flex: 1;

      & > .title {
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        margin-bottom: 5px;
      }
    }

    & .before {
      border-right: 1px solid #868e96;
    }
  }
`;

export const EventPreviewWrapStyle = styled.div`
  flex: 1 1 auto;
  background: #fff;
  width: 400px;
  height: 460px;
  margin: auto;

  .amondz-slider {
    .slick-slide {
      border: 1px solid #868e96;

      .event-image {
        img {
          width: 398px;
          cursor: pointer;
          margin: auto;
        }
      }
    }
  }
`;
